import { INIT_CONFIG_FAILURE, INIT_CONFIG_REQUEST, INIT_CONFIG_SUCCESS } from "./actionTypes";
import { validateTegoJitsiServerConfig } from "./funtions";
export function initConfigRequest(config) {
    return async (dispatch, getState) => {
        // Despachar intencion.
        dispatch({
            type: INIT_CONFIG_REQUEST
        });
        // cargar configuracion.
        const tegoConfig = validateTegoJitsiServerConfig(config);
        // despachar resolucion.
        if (tegoConfig.success) {
            dispatch(initConfigSuccess(tegoConfig.urls));
        }
        else {
            dispatch(initConfigFailure(tegoConfig.error));
        }
    };
}
function initConfigSuccess(urls) {
    return (dispatch, getState) => {
        // Despachar exito.
        dispatch({
            type: INIT_CONFIG_SUCCESS,
            payload: {
                urls
            }
        });
    };
}
function initConfigFailure(error) {
    return {
        type: INIT_CONFIG_FAILURE,
        error
    };
}
